import {NgModule} from '@angular/core';
import {SignInComponent} from './sign-in/sign-in.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {AuthenticationRoutingModule} from './auth.routing.module';
import {IonicModule} from '@ionic/angular';
import {SignUpComponent} from './sign.up/sign.up.component';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {AccountVerificationComponent} from './account-verification/account-verification.component';
import {SharedModule} from '../../../components/shared.module';
import {AboutYouComponent} from './about-you/about-you.component';
import {UserAccountComponent} from './user-account/user-account.component';
import {TermsAndConditionComponent} from 'src/app/components/terms-condition/terms-condition.component';
import {PrivacyComponent} from 'src/app/components/privacy/privacy.component';
import {ReportDetailsComponent} from './reports/report-details/report-details.component';
import {ChooseEmotionComponent} from './reports/choose-emotion/choose-emotion.component';
import {ReportPublishedComponent} from './reports/report-published/report-published.component';
import {CreateAccountSuccessComponent} from './user-account/create-account-success.component';

@NgModule({
  declarations: [
    SignInComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    AccountVerificationComponent,
    AboutYouComponent,
    PrivacyComponent,
    ReportDetailsComponent,
    ReportPublishedComponent,
    ChooseEmotionComponent,
    UserAccountComponent,
    CreateAccountSuccessComponent
  ],
  imports: [
    HttpClientModule,
    AuthenticationRoutingModule,
    IonicModule,
    ReactiveFormsModule,
    TranslateModule,
    CommonModule,
    FormsModule,
    SharedModule
  ],
  exports: [
    SignInComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ReportDetailsComponent
  ]
})
export class AuthModule {
}
